export const publicityGallery = [
  {
    src: "assets/product/Gallery1.jpg",
    alt: "Espacio interior"
  },
  {
    src: "assets/product/Gallery12.jpg",
    alt: "Espacio diseñado interior"
  },

  {
    src: "assets/product/Gallery3.jpg",
    alt: "Vista de producto"
  },
  {
    src: "assets/product/Gallery4.jpg",
    alt: "Vista frontal"
  },
  {
    src: "assets/product/Gallery11.jpg",
    alt: "Producto en uso"
  },
  {
    src: "assets/product/Gallery6.jpg",
    alt: "Detalle producto"
  },
  {
    src: "assets/product/Gallery7.jpg",
    alt: "Primer plano"
  },
  {
    src: "assets/product/Gallery8.jpg",
    alt: "Creación publicitaria"
  },
  {
    src: "assets/product/Gallery2.jpg",
    alt: "Fotografía temporada navideña"
  },
  {
    src: "assets/product/Gallery5.jpg",
    alt: "Composición creativa"
  },
  {
    src: "assets/product/Gallery10.jpg",
    alt: "Producto en espacio propio"
  },
  {
    src: "assets/product/Gallery9.jpg",
    alt: "Espacio diseñado"
  }
];
